export enum MemberManagementScenarios {
    RemoveGroupMember,
    PromoteGroupMember,
    DemoteGroupOwner,
}